import styled from "styled-components";

export const ProjectsContainer = styled.section``;

export const ProjectsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
`;
